import React from "react";
import {Navigate} from "react-router-dom";

import Page from "../../elements/Page/Page";
import PasswordBox from "./PasswordBox";
import PersonalDataBox from "./PersonalDataBox";
import PaymentBox from "./PaymentBox";

import {isLoggedIn} from "../../utils/utils";

const SettingsPage = () => {

  if (!isLoggedIn()) {
    return <Navigate to="/login" replace={true} />
  }

  return (
    <Page headline={"Einstellungen"}>
      <PersonalDataBox/>
      <PasswordBox/>
      <PaymentBox/>
    </Page>
  );
}

export default SettingsPage;